module.exports = __webpack_public_path__ + "img/m_head.03006545.png";